export const groupSessions = (sessions) => {
  if (!sessions) return {};

  const groups = {
    "Today": [],
    "Yesterday": [],
    "Previous 7 Days": [],
    "Older": [],
  };

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const lastWeek = new Date(today);
  lastWeek.setDate(lastWeek.getDate() - 7);

  sessions.forEach((session) => {
    const dateStr = session?.updated_at || session?.updatedAt;
    if (!dateStr) {
      groups["Older"].push(session);
      return;
    }

    const date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      groups["Older"].push(session);
      return;
    }

    if (date >= today) {
      groups["Today"].push(session);
    } else if (date >= yesterday) {
      groups["Yesterday"].push(session);
    } else if (date >= lastWeek) {
      groups["Previous 7 Days"].push(session);
    } else {
      groups["Older"].push(session);
    }
  });

  return Object.fromEntries(
    Object.entries(groups).filter(([_, group]) => group.length > 0),
  );
};
